// bootstrap Components
import { Container, Row } from "react-bootstrap";
// product component
import Product from "./Product";
//menu items images
import item1 from "../Images/item1.jpg";
import item2 from "../Images/item2.jpg";

// This component creates the layout to display the Product component.
function Shop() {
  return (
    <section className="products">
      <Container>
        <h1 className="section-heading">OUR MENU</h1>
        <p className="text-center">Little things make us best in town.</p>
        {/* below I have reused the product component passing different props for each item */}
        <Row>
          <Product
            id="1"
            name="menu Item 1"
            price="R85.99"
            description="Lorem ipsum dolor sit amet consectetur adipisicing."
            image={item1}
          />
          <Product
            id="2"
            name="menu Item 2"
            price="R99.99"
            description="Lorem ipsum dolor sit amet consectetur adipisicing."
            image={item2}
          />
          <Product
            id="3"
            name="menu Item 3"
            price="R35.99"
            description="Lorem ipsum dolor sit amet consectetur adipisicing."
            image={item1}
          />
          <Product
            id="4"
            name="menu Item 4"
            price="R45.99"
            description="Lorem ipsum dolor sit amet consectetur adipisicing."
            image={item2}
          />
        </Row>
      </Container>
    </section>
  );
}

export default Shop;
